import type { Price } from '../../api-models'
import { createHttpEndpoint } from '../../utils'
import type { BuybackModelDiagnostic } from '../models'

// TODO [BBACK-5697] This interface has some legacy keys
export interface GetOfferResponse {
  title: string
  thumbnail: string
  standard_price: Price
  // deprecated
  price: number
  // deprecated
  price_with_currency: string
  // not used
  sourcing_listing: string
  // not used
  date_created: string
  // not used
  has_shipping_choices: boolean
  hasBankDetails: boolean
  // deprecated
  wording: Array<{
    title: string
    paragraphs: string[]
  }>
  diagnostic_summary: Array<{
    label: string
    value: string
  }>
  diagnostic_payload: BuybackModelDiagnostic
}

/**
 * Retrieve offer
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/GetOfferDetails}
 */
export const getOffer = createHttpEndpoint<GetOfferResponse>({
  method: 'GET',
  operationId: 'getBuybackOffer',
  path: '/bm/sourcing/offer/:sourcingListingId',
})
